"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function () {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: bodyRef,
    isVisible: bodyVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const paragraphs = [{
    dropCap: "W",
    rest: "e believe that digital inclusion is a fundamental right, not an afterthought. Our commitment to accessibility is woven into the very fabric of our platform, ensuring that every user, regardless of their physical or cognitive abilities, can navigate our tools with ease and dignity. We continuously audit our interfaces against global standards to remove barriers and foster an environment where information is truly universal."
  }, {
    dropCap: "O",
    rest: "ur development process integrates assistive technology testing from the first line of code. By prioritizing semantic structure, keyboard navigability, and screen reader compatibility, we create a seamless experience for everyone. We recognize that accessibility is an evolving journey, and we are dedicated to listening to our community to refine and improve our standards every single day."
  }];
  const closingParagraph = {
    dropCap: "T",
    rest: "his is our promise to you: a digital space that respects your autonomy and supports your needs. We invite you to share your feedback on your experience with our site, as your insights are the most valuable tool we have in building a more inclusive future for all our users."
  };
  return <section data-section-id="3855" id="accessibility-statement" className="bg-background text-foreground py-24 md:py-32 lg:py-40 px-6 md:px-10 lg:px-16">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          {}
          <div className="lg:col-span-4">
            <div ref={headerRef} className={`lg:sticky lg:top-32 transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
              <p className="font-mono text-xs uppercase tracking-[0.25em] mb-10" style={{
              color: "var(--chart-4)"
            }}>
                N&deg;02 &mdash; Our Commitment
              </p>
              <h2 className="font-default font-light leading-[1.02] text-foreground" style={{
              fontSize: "clamp(2rem, 5vw, 3.5rem)"
            }}>
                Digital access,
                <br />
                for <em className="italic font-light">everyone.</em>
              </h2>
              <div className="mt-10 h-px w-10" style={{
              backgroundColor: "var(--chart-4)"
            }} />
            </div>
          </div>

          {}
          <div className="lg:col-span-8">
            <div ref={bodyRef} className={`max-w-[580px] transition-all duration-1000 ease-out ${bodyVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              {paragraphs.map((p, i) => <div data-index={i} key={i} className="mb-14">
                  <p className="font-default text-[18px] leading-[1.75] text-foreground/85">
                    <span className="font-default font-light float-left mr-3 mt-1 leading-none" style={{
                  fontSize: "4rem",
                  color: "var(--chart-4)",
                  lineHeight: "0.85"
                }}>
                      {p.dropCap}
                    </span>
                    {p.rest}
                  </p>
                </div>)}

              {}
              <blockquote className="my-16 pl-6 italic font-default text-foreground/90" style={{
              fontSize: "1.5rem",
              lineHeight: "1.5",
              borderLeft: "2px solid var(--chart-4)",
              minHeight: "80px"
            }}>
                &ldquo;True innovation is measured by how many people can participate in it. We build for the many, not the few.&rdquo;
              </blockquote>

              {}
              <figure className="my-16 -mx-2">
                <div className="relative w-full overflow-hidden" style={{
                aspectRatio: "16/9"
              }}>
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/inclusive_digital_design.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/inclusive_digital_design.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/inclusive_digital_design.png-wvc-sizes" alt="Inclusive digital design and accessibility testing" loading="lazy" decoding="async" className="w-full h-full object-cover" />
                </div>
                <figcaption className="mt-4 italic font-default text-sm text-muted-foreground" style={{
                fontSize: "0.875rem"
              }}>
                  Plate I. &mdash; Standardized accessibility audit, interface testing, Q3.
                </figcaption>
              </figure>

              {}
              <div className="mb-10">
                <p className="font-default text-[18px] leading-[1.75] text-foreground/85">
                  <span className="font-default font-light float-left mr-3 mt-1 leading-none" style={{
                  fontSize: "4rem",
                  color: "var(--chart-4)",
                  lineHeight: "0.85"
                }}>
                    {closingParagraph.dropCap}
                  </span>
                  {closingParagraph.rest}
                </p>
              </div>

              {}
              <p className="italic font-default text-foreground/90 mt-12" style={{
              fontSize: "1.25rem"
            }}>
                &mdash; The Engineering Team
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}